import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash";
import axios from "axios"

import { Edit, FilterListRounded, MoreVertRounded,AddCircle, CloudDownloadRounded} from '@mui/icons-material';
import { Grid, Checkbox, Menu, MenuItem, TableContainer,Typography,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    IconButton,  
} from '@mui/material';

import { normalizeStr } from '../../../utils/generalFuncs';
import { EnhancedTableHead, EnhancedTableToolbar } from '../../../container/MUI/EnhancedTable';
import UserSpendingForm from '../../UserView/UserSpendings/UserSpendingForm'
import SpendingsUpdate from './SpendingsDemandUpdate'
import Notif from "../../common/Notif";
import SpendingDetails from '../../Spendings/SpendingDetails';
import FilterSpendings from '../../Spendings/FilterSpendings';
import PaymentForm from '../Payments/PaymentFormAll';
import Pagination from '../../../container/MUI/Pagination';
import Currency from '../../common/Currency';
import DeleteDialog from '../../common/DeleteDialog';
import SupplierSingle from '../Suppliers/SupplierSingle';
import LabelSingle from '../Labels/LabelSingle';
import PaymentUserForm from '../Payments/PaymentUserForm';
import ProjectSingle from '../Projects/ProjectSingle';

const STATUS = {
    "WAITING_UPDATE": "À Corriger",
    "WAITING_VALIDATION": "En Attente",
    "VALIDATE": "Validé",
    "REFUSED": "Refusé"
}

class SpendingsDemandAdmin extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,

        newSpending : false,
        validateSpending : false,
        openDetails: false, 
        selectedSpending: {},
        
        openSupplier: false,
        selectedSupplier: {},
        openLabel: false,
        selectedLabel: {},
        openProject: false,
        selectedProject: {},

        filteredList: Object.values(this.props.SPENDINGS),
        spending: {},
        toDelete: {},

        checkedSpendings: [],
        singlePayment: [],

        searchLabel: {value: "", label: ""},
        searchProject: {value: "", label: ""},
        searchCategory: {value: "", label: ""},
        searchSubCategory: "",
        searchSupplier: {value: "", label: ""},
        searchFacture: "",
        searchUser: {value: "", label: ""},
        pay_status: "",
        spend_status: "",
        searchMonth: "",
        searchYear: "",

		notif:{
			openNotif: "",
			variant: "",
			message: "",
        },
        openFilters: false,
        anchorEl: null, 
        openMenu: "", 
        loading: false,
        url: ""
    }
    componentDidMount = () => {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.EQUIPEMENTS) ){
            this.props.fetchEquipements()
        }
        if(isEmpty(this.props.VEHICULES) ){
            this.props.fetchVehicules()
        }
        
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    // filterLabels = (spending) => {
    //     const { LABELS } = this.props;
    //     const { searchLabel } = this.state;
    //     let match = false

    //     if (searchLabel) {
    //         if (spending.spending_demand_labels) {
    //             let searchLabels = searchLabel.split(", ") //!\ Namelist
    //             let spendingIDList = spending.spending_demand_labels.split(", ") //!\ IDlist
    //             let spendingLabelsList = []
    //             spendingIDList.forEach( 
    //                 labelID => (
    //                     LABELS && LABELS[labelID] && spendingLabelsList.push( normalizeStr(LABELS[labelID].label_name) )
    //                 )
    //             )

    //             let nbMatch = 0 
    //             searchLabels.forEach( searching => {
    //                 let find = spendingLabelsList.filter( label => label.indexOf(normalizeStr(searching)) > -1)

    //                 if(!isEmpty(find)){
    //                     nbMatch++
    //                     spendingLabelsList.splice(spendingLabelsList.indexOf(find[0]), 1) // to prevent double match on same item
    //                 } 
    //             })
    //             match = nbMatch === size(searchLabels)

    //         } else {
    //             match = false
    //         }
    //     } else {
    //         match = true
    //     }

    //     return match
    // }
    // filterSuppliers = (spending) => {
    //     const { SUPPLIERS } = this.props;
    //     const { searchSupplier } = this.state;
    //     let match = false

    //     if (searchSupplier && SUPPLIERS) {
    //         if (spending.spending_demand_supplier) {

    //             let searching = searchSupplier.split(", ") 
    //             let supplier = normalizeStr(SUPPLIERS[spending.spending_demand_supplier].supplier_name)
                
    //             searching.forEach( search => {
    //                 if(supplier.indexOf(normalizeStr(search)) > -1 ) {
    //                     match = true
    //                 }
    //             })

    //         } else {
    //             match = false
    //         }
    //     } else {
    //         match = true
    //     }

    //     return match
    // }

    filterCat = (list) => {
        const { CATEGORIES } = this.props;
        const { searchCategory } = this.state;
        let newList = []
        console.log('====================================');
        console.log({searchCategory});
        console.log('====================================');
        list.forEach(item => {
            if( !searchCategory.value ) {
                newList.push(item) 
            } else if( CATEGORIES.ALL[searchCategory.value].includes(item.spending_demand_category) ) {
                newList.push(item) 
            }
        })
        
        return newList
    }
    filterSubCat = (list) => {
        const { ALL, LIST } = this.props.CATEGORIES;
        const { searchSubCategory } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory ) {
                newList.push(item) 
            } else if( item.spending_demand_category === searchSubCategory ) {
                newList.push(item) 
            } else if ( LIST[searchSubCategory] && LIST[searchSubCategory].includes(item.spending_demand_category)) {
                newList.push(item) 
            }
        })
        return newList
    }
    filterSubCat2 = (list) => {
        const { searchSubCategory2 } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory2 ) {
                newList.push(item) 
            } else if( item.spending_demand_category === searchSubCategory2) {
                newList.push(item) 
            }
        })
        return newList
    }
    filterStatus = (list) => {
        const { pay_status } = this.state;
        

        if (pay_status === "payed") {
            list = list.filter( item => item.spending_demand_fully_paid)
        } else if (pay_status === "not_payed") {
            list = list.filter( item => !item.spending_demand_fully_paid)
        }


        return list
    }
    filterStatusSpending = (list) => {
        const { spend_status } = this.state;
        
        if (spend_status !== "") {
            list = list.filter( item => item.spending_demand_status === spend_status)
        }

        return list
    }
    getFilteredList = () => {
        const { SPENDINGS } = this.props;
        const { searchUser, searchFacture, searchSupplier, searchLabel, searchMonth, searchYear, searchProject } = this.state;
        // labels
        // let list = Object.values(SPENDINGS).filter(item => this.filterLabels(item))
        let list = Object.values(SPENDINGS)
        if( !isEmpty(searchLabel.value)) {
            list = list.filter( item => item.spending_demand_labels.split(", ").includes(searchLabel.value))
        }
        if( Array.isArray(searchLabel) && !isEmpty(searchLabel) ) {
            let newList = []
            let searchLabelList = searchLabel.map(item => item.value )
            searchLabelList.forEach(label => {
                newList.push(...list.filter( item => item.spending_demand_labels.split(", ").includes(label) ))
            })
            list = newList
        }
        if( !isEmpty(searchProject.value)) {
            list = list.filter( item => item.spending_demand_project.split(", ").includes(searchProject.value))
        }
        if( Array.isArray(searchProject) && !isEmpty(searchProject) ) {
            let newList = []
            let searchProjectList = searchProject.map(item => item.value )
            searchProjectList.forEach(label => {
                newList.push(...list.filter( item => item.spending_demand_project.split(", ").includes(label) ))
            })
            list = newList
        }

        // suppliers
        // list = list.filter(item => this.filterSuppliers(item))
        if( !isEmpty(searchSupplier.value)) {
            list = list.filter( item => item.spending_demand_supplier === searchSupplier.value)
        }
        if( Array.isArray(searchSupplier) && !isEmpty(searchSupplier) ) {
            let itemList = searchSupplier.map(item => item.value )
            list = list.filter( item => itemList.includes(item.spending_demand_supplier))
        }

        // users
        // if(!isEmpty(searchUser)){
        //     list = list.filter(item => item.spending_demand_user === searchUser)
        // }
        if( !isEmpty(searchUser.value)) {
            list = list.filter( item => item.spending_demand_user === searchUser.value)
        }
        if( Array.isArray(searchUser) && !isEmpty(searchUser) ) {
            let itemList = searchUser.map(item => item.value )
            list = list.filter( item => itemList.includes(item.spending_demand_user))
        }

        if(!isEmpty(searchFacture)){
            list = list.filter(item => item.spending_demand_id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
        }
        // categories
        list = this.filterCat(list)
        // subCat
        list = this.filterSubCat(list)
        // subCat2
        list = this.filterSubCat2(list)
        // pay status
        list = this.filterStatus(list)
        // pay status spending
        list = this.filterStatusSpending(list)


        if( !isEmpty(searchMonth.value) ) {
            list = list.filter( item => new Date(item.spending_demand_date).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            list = list.filter( item => itemList.includes(new Date(item.spending_demand_date).getMonth()))
        } 

        if( searchYear ) {
            list = list.filter( item => new Date(item.spending_demand_date).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            list = list.filter( item => itemList.includes(new Date(item.spending_demand_date).getFullYear()))
        } 


        return list
    }

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }

    handleSelectAllClick = event => {
        if (event.target.checked) {
            let filteredList = this.getFilteredList()
            const newSelecteds = filteredList.map(item => item.spending_demand_id);
            this.setState({
                checkedSpendings : newSelecteds
            });
          return;
        }
        this.setState({
            checkedSpendings :[]
        });  
    };
    handleSelect = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
                page: 0,
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
            })

        }
    }
    
    handleClick = (event, name) => {
        const { checkedSpendings } = this.state;
        const selectedIndex = checkedSpendings.indexOf(name);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedSpendings, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedSpendings.slice(1));
        } else if (selectedIndex === checkedSpendings.length - 1) {
            newSelected = newSelected.concat(checkedSpendings.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedSpendings.slice(0, selectedIndex),
                checkedSpendings.slice(selectedIndex + 1),
            );
        }
    
        // console.log('====================================');
        // console.log({newSelected, name, event});
        // console.log('====================================');
        this.setState({
            checkedSpendings : newSelected
        });
    };
    getSpendingList = (list, bckg) => {
        const { rowsPerPage, page, checkedSpendings, openMenu, anchorEl } = this.state;
        const { CATEGORIES, USERS, LABELS, SUPPLIERS, PROJECTS } = this.props;

        const isSelected = name => checkedSpendings.indexOf(name) !== -1;

        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( (item, index) => {

            let category = CATEGORIES.CHILD[item.spending_demand_category]
            let user = isEmpty(USERS) ? {} : USERS[item.spending_demand_user]
            let userInfo = (user.username && user.lastname) ? `${user.username[0]}.${user.lastname[0]}.` : user.email
            // let userInfo = user.username && user.lastname ? 
            // `${user.username[0].toUpperCase()}.${user.lastname[0].toUpperCase()}` : 
            // user.email

            let labels = LABELS && item.spending_demand_labels && item.spending_demand_labels.split(", ")
            let projects = PROJECTS && item.spending_demand_project && item.spending_demand_project.split(", ")
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_demand_supplier]

            let isItemSelected = isSelected(item.spending_demand_id)
            const labelId = `enhanced-table-checkbox-${index}`;

            if( item.spending_demand_status === "WAITING_VALIDATION" ){
                bckg = "cornsilk"
            } 
            if( item.spending_demand_status === "WAITING_UPDATE" ){
                bckg = "#f7d0d6"
            } 
            return (
                <TableRow hover key={item.spending_demand_id} className="clickable" style={{ backgroundColor: bckg }} 
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={item.spending_demand_id}
                    selected={ isItemSelected }
                >
                    <TableCell 
                        padding="checkbox"
                    >
                    {!item.spending_demand_fully_paid && item.spending_demand_status === "VALIDATE" &&
                        <Checkbox
                            onClick={event => this.handleClick(event, item.spending_demand_id)}
                            disabled={item.spending_demand_fully_paid}
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    }
                    </TableCell>
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {new Date(item.spending_demand_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                        title={(user.username && user.lastname) && `${user.username} ${user.lastname}`}
                    >
                        {userInfo}
                    </TableCell>                     
                    
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {STATUS[item.spending_demand_status]}
                    </TableCell>     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        { category && category.category_name}
                    </TableCell>                     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {item.spending_demand_desc}
                    </TableCell>   
                    <TableCell 
                        onClick={() => this.setState({openSupplier: true, selectedSupplier: supplier }) }
                        className="a-like"
                    >
                        {supplier && supplier.supplier_name}
                    </TableCell>   
                    <TableCell >
                        {labels && labels.map( (label, index) =>
                        <Fragment key={label}>
                            {index !== 0 && " | "}
                            <span
                                onClick={() => this.setState({openLabel: true, selectedLabel: LABELS[label] }) }
                                className="a-like"
                            >
                                {LABELS[label].label_name}
                            </span> 
                        </Fragment>
                        )}
                    </TableCell>   
                    <TableCell >
                        {projects && projects.map( (project, index) =>
                        <Fragment key={project}>
                            {index !== 0 && " | "}
                            <span
                                onClick={() => this.setState({openProject: true, selectedProject: PROJECTS[project] }) }
                                className="a-like"
                            >
                                {PROJECTS[project] && PROJECTS[project].project_name}
                            </span> 
                        </Fragment>
                        )}
                    </TableCell>   
                                   
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        <Currency value={item.spending_demand_amountTTC} />
                    </TableCell>                     
                    <TableCell 
                        onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                    >
                        {!item.spending_demand_fully_paid &&
                            <Currency value={item.spending_demand_rest_to_pay} />
                        }
                    </TableCell>                     
                    <TableCell>
                        {isEmpty(this.state.checkedSpendings) &&
                        <Fragment>
                            <IconButton 
                                aria-controls={`option-menu${item.spending_demand_id}`} 
                                aria-haspopup="true"
                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.spending_demand_id}) }>
                                <MoreVertRounded/>
                            </IconButton>

                            <Menu
                                id={`option-menu${item.spending_demand_id}`}
                                anchorEl={anchorEl}
                                // keepMounted
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === item.spending_demand_id}
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >
                                {(item.spending_demand_status === "WAITING_VALIDATION" || item.spending_demand_status === "WAITING_UPDATE") && 
                                    <MenuItem onClick={() => this.handleOpenValidate(item) } >Compléter</MenuItem>
                                }
                                {item.spending_demand_status === "VALIDATE" &&
                                        <MenuItem onClick={() => this.handleOpenValidate(item) } >Modifier</MenuItem>
                                }
                                {item.spending_demand_status === "VALIDATE" && !item.spending_demand_fully_paid &&
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPayment: true, 
                                            singlePayment: [item.spending_demand_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement
                                    </MenuItem>
                                }
                                {item.spending_demand_status === "VALIDATE" && !item.spending_demand_fully_paid &&
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPaymentUser: true, 
                                            singlePayment: [item.spending_demand_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement Collaborateur
                                    </MenuItem>
                                }
                                                  
                                {!item.spending_demand_total_payed &&
                                    <MenuItem onClick={() => this.setState({ deleteSpending: true, toDelete: item, openMenu: "", anchorEl:null}) }>Supprimer</MenuItem>
                                }
                            </Menu>
                        </Fragment>
                        }
                    </TableCell>
                </TableRow>
            )
        })
    }

    displayList = () => {
        const { SPENDINGS } = this.props;

        let tab = []
        let rows = 0
        if (!isEmpty(SPENDINGS)){
            let filteredList = this.getFilteredList()
            let filterWaiting = filteredList.filter(item => (item.spending_demand_status === "WAITING_VALIDATION"))
            let filterUpdate = filteredList.filter(item => (item.spending_demand_status === "WAITING_UPDATE"))
            let filterValidate = filteredList.filter(item => (item.spending_demand_status === "VALIDATE"))

            let all = [].concat(filterWaiting, filterUpdate, filterValidate)
            rows = size(all)
            tab.push( this.getSpendingList(all) )
            // tab.push(this.getSpendingList(filterWaiting, "cornsilk"), this.getSpendingList(filterUpdate, "#f7d0d6"), this.getSpendingList(filterValidate))
        }
        return [tab, rows]
    }

    handleOpenValidate = (spending) => {
		this.setState({
			spending,
            validateSpending: true,
            openMenu: "",
            anchorEl: null
		})
	}

    handleChange = (e) => {
        const { name, value} = e.target;
        if (name === "searchCategory"){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else if (name === "searchSubCategory"){
            this.setState({
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else {
            this.setState({
                [name]: value,
                page:0,
            })
        }
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if (field === "searchCategory" && !isEmpty(option.value)){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [field]: option,
                page: 0,
            })
        } else if(option){
            this.setState({                
                [field]: option,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                page: 0,
                // checkedItems :[]
            })

        }
    }
    handleDelete = async () => {
        const { toDelete } = this.state;
        await this.props.deleteSpending(toDelete)
        if(this.props.STATE.spendings.error){
            this.notif(true, "error", this.props.STATE.spendings.error)
        } else {
            
            this.notif(true, "success", "Dépense supprimée")
            this.setState({
                deleteSpending: false,
                toDelete: {},
            })
        }
    }
    notif = (openNotif, variant, message) => {
        this.setState({
            notif:{
                openNotif,
                variant,
                message
            }
        })
    }

    render() {
        const { 
            page, 
            rowsPerPage, 
            newSpending, 
            validateSpending, 
            spending, 
            openDetails, 
            selectedSpending, 
            openSupplier, 
            selectedSupplier, 
            openLabel, 
            selectedLabel, 
            openProject, 
            selectedProject, 
            openFilters, 
            newPayment, 
            newPaymentUser, 
            checkedSpendings,
            singlePayment,
            deleteSpending,
            toDelete 
        } = this.state;
        const { 
            openNotif, 
            variant, 
            message 
        } = this.state.notif;

        const { SPENDINGS, SUPPLIERS, CATEGORIES, BANKS, LABELS, PAYMENTS, USERS, PROJECTS } = this.props;
        const spendingsList = this.displayList()

        console.log('spendinsList---------')
        console.log(this.displayList())
        return (
            <div >
                {(openNotif && variant && message) && 
                    <Notif
                        open={openNotif}
                        onClose={() => this.notif(false)}
                        variant={variant}
                        message={message}
                    />
                }
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_demand_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        PROJECTS={PROJECTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_demand_category]} 
                        spending={selectedSpending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                {openSupplier && selectedSupplier && 
                    <SupplierSingle 
                        open={openSupplier} 
                        supplier={selectedSupplier}
                        handleClose={()=> this.setState({openSupplier: false, selectedSupplier: {}})}
                        {...this.props} 
                    />
                }
                {openLabel && selectedLabel && 
                    <LabelSingle 
                        open={openLabel} 
                        label={selectedLabel}
                        handleClose={()=> this.setState({openLabel: false, selectedLabel: {}})}
                        {...this.props} 
                    />
                }
                {openProject && selectedProject && 
                    <ProjectSingle 
                        open={openProject} 
                        project={selectedProject}
                        handleClose={()=> this.setState({openProject: false, selectedProject: {}})}
                        {...this.props} 
                    />
                }
                {newSpending && 
                    // <SpendingsUpdate
                    //     handleClose={() => this.setState({ newSpending: false })}
                    //     notif={this.notif}
                    //     {...this.props}
                        
                    // />
                    <UserSpendingForm
                        admin
                        handleClose={() => this.setState({ newSpending: false })}
                        notif={this.notif}
                        CATEGORIES={this.props.CATEGORIES}
                        STATE={this.props.STATE}
                        newSpending={this.props.newSpending}
                        updateUserSpending={this.props.updateUserSpending}
                        createNewCategory={this.props.createNewCategory}
                        {...this.props}
                    />
                }
                {validateSpending && spending && 
                    <SpendingsUpdate
                        handleClose={() => this.setState({ validateSpending: false, spending: {} }) }
                        // notif={this.notif }
                        spending={this.state.spending}
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(checkedSpendings) &&
                    <PaymentForm
                        spendings={checkedSpendings}
                        handleClose={() => this.setState({ newPayment: false, checkedSpendings:[] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(singlePayment) &&
                    <PaymentForm
                        spendings={singlePayment }
                        handleClose={() => this.setState({ newPayment: false, singlePayment: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPaymentUser && !isEmpty(checkedSpendings) &&
                    <PaymentUserForm
                        spendings={checkedSpendings }
                        handleClose={() => this.setState({ newPaymentUser: false, checkedSpendings: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {newPaymentUser && !isEmpty(singlePayment) &&
                    <PaymentUserForm
                        spendings={singlePayment }
                        handleClose={() => this.setState({ newPaymentUser: false, singlePayment: [] })}
                        // notif={this.notif}
                        {...this.props}
                    />
                }
                {deleteSpending && !isEmpty(toDelete) &&
                    <DeleteDialog
                        title={"la dépense"}
                        open={true}
                        close={() => this.setState({ deleteSpending: false, toDelete: {} })}
                        // notif={this.notif}
                        handleSubmit={this.handleDelete}
                        // {...this.props}
                    />
                }
                    <Typography variant="h6" id="tableTitle">
                        Liste des Dépenses
                    </Typography>
                    
                    <Grid container spacing={2} >
                    
                        <Grid item sm={6} xs={12}>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick={() => this.setState({ openFilters: !this.state.openFilters })}
                                startIcon={<FilterListRounded />}
                            >
                                Filtres
                            </Button>
                        </Grid>
                        <Grid item sm={6} xs={12} style={{textAlign: "right"}}>
                            <Button 
                                variant="contained" 
                                color="secondary" 
                                onClick={() => this.setState({ newSpending: true })} 
                                title="Nouvelle Dépense"
                                startIcon={<AddCircle />}
                            >
                                Ajouter
                            </Button>
                            
                            <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/spendings/csv")} title="Télécharger" disabled={this.props.downloading}>
                                <CloudDownloadRounded />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {openFilters && 
                        <FilterSpendings 
                            CATEGORIES={CATEGORIES}
                            USERS={USERS}
                            SUPPLIERS={SUPPLIERS}
                            LABELS={LABELS}
                            PROJECTS={PROJECTS}
                            handleClose={() => this.setState({ openFilters: false })}
                            handleChange={this.handleChange}
                            handleChangeMulti={this.handleChangeMulti}
                            handleSelect={this.handleSelect}
                            admin
                            {...this.state}
                        />
                    }

                    {!isEmpty(checkedSpendings) &&
                        <EnhancedTableToolbar 
                            numSelected={checkedSpendings.length} 
                            action={() => this.setState({ newPayment: true })}
                            actionCollab={() => this.setState({ newPaymentUser: true })}
                        />
                    }
                    <TableContainer>
                        <Table>
                            <EnhancedTableHead
                                // classes={classes}
                                numSelected={size(checkedSpendings)}
                                // onSelectAllClick={this.handleSelectAllClick}
                                rowCount={spendingsList[1]}
                            />
                       
                            <TableBody>
                                {spendingsList[0]}
                              
                            </TableBody>
                            {spendingsList[1] > 10 &&
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[20, 30]}
                                            labelRowsPerPage="Lignes par Page"
                                            colSpan={12}
                                            count={spendingsList[1]}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                native: true,
                                            }}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                            ActionsComponent={Pagination}
                                        />
                                    </TableRow>
                                </TableFooter>
                            }
                        </Table> 
                    </TableContainer>
               </div>
        );
    }
}

export default  SpendingsDemandAdmin
